import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import UnitSelectorModal from "./UnitSelectorModal";
import PaymentMethodModal from "./PaymentMethodModal";
import SummaryModal from "./SummaryModal";
import PinModal from "./PinModal";
import SuccessModal from "./SuccessModal";
import FailedModal from "./FailedModal";
import postService from "../../Services/post-service";

export default function BuyUnits({
  open,
  handleClose,
  number,
  amount,
  id,
  type,
  details,
  closeDrawer,
}) {
  const [step, setStep] = useState(1);
  const [unit, setUnit] = useState(1);
  const [method, setMethod] = useState("wallet");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setStep(1);
      setUnit(1);
      setMethod("wallet");
    }
  }, [open]);

  const closeAll = () => {
    setStep(1);
    if (handleClose) handleClose();
  };

  const handleUnitContinue = (selectedUnit) => {
    setUnit(selectedUnit);
    setStep(2);
  };

  const handleMethodContinue = (selectedMethod) => {
    setMethod(selectedMethod);
    setStep(3);
  };

  const handleSummaryPay = () => {
    setStep(4);
  };

  const handlePinConfirm = (pin) => {
    setIsLoading(true);
    postService
      .financeAListing(id, unit, pin)
      .then((response) => {
        setIsLoading(false);
        setStep(5);
      })
      .catch((error) => {
        setIsLoading(false);
        const message =
          error?.response?.data?.description ||
          "Something went wrong. Please try again.";
        setErrorMessage(message);
        setStep(6);
      });
  };

  const handleViewTransaction = () => {
    closeAll();
    if (closeDrawer) closeDrawer();
    navigate("/wallet");
  };

  return (
    <div>
      <Outlet />

      {/*  Unit Selector */}
      <UnitSelectorModal
        open={open && step === 1}
        handleClose={closeAll}
        details={{ ...details, pricePerUnit: amount, type: type }}
        initialUnit={unit}
        onContinue={handleUnitContinue}
      />

      {/*  Payment Method */}
      <PaymentMethodModal
        open={open && step === 2}
        handleClose={closeAll}
        onBack={() => setStep(1)}
        selectedMethod={method}
        onContinue={handleMethodContinue}
      />

      {/*  Summary */}
      <SummaryModal
        open={open && step === 3}
        handleClose={closeAll}
        onBack={() => setStep(2)}
        details={{ ...details, pricePerUnit: amount, type: type }}
        unit={unit}
        onPay={handleSummaryPay}
      />

      {/*  Pin */}
      <PinModal
        open={open && step === 4}
        handleClose={closeAll}
        onBack={() => setStep(3)}
        onConfirm={handlePinConfirm}
        isLoading={isLoading}
      />

      {/* Success */}
      <SuccessModal
        open={open && step === 5}
        handleClose={closeAll}
        handleViewTransaction={handleViewTransaction}
        unit={unit}
        details={details}
        type={type}
      />

      {/* Failed */}
      <FailedModal
        open={open && step === 6}
        handleClose={closeAll}
        handleRetry={() => setStep(4)}
        errorMessage={errorMessage}
      />
    </div>
  );
}
